import { observable, action, runInAction } from 'mobx';

import { StoreExt } from '@utils/reactExt';

export class InsuranceStatementStore extends StoreExt {
    @observable
    insuranceStatements: IInsuranceStatementStore.IIsuranceStatement[] = [
        {
            title: this.$intl.get('insurance.info.accordion.item3.label1'),
            read: false,
            key: '1'
        },
        {
            title: this.$intl.get('insurance.info.accordion.item3.label2'),
            read: false,
            key: '2'
        },
        {
            title: this.$intl.get('insurance.info.accordion.item3.label3'),
            read: false,
            key: '3'
        },
        {
            title: this.$intl.get('insurance.info.accordion.item3.label4'),
            read: false,
            key: '4'
        }
    ];

    @observable
    visible: boolean = false;

    @observable
    insuranceStatement?: IInsuranceStatementStore.IIsuranceStatement | null;

    @action
    viewDetailes = (insuranceStatement: IInsuranceStatementStore.IIsuranceStatement) => {
        this.insuranceStatement = insuranceStatement;
        this.visible = true;
    };

    @action
    hideModal = () => {
        this.visible = false;
        this.insuranceStatement = null;
    };

    @action
    changeReadStatus = ({ key, readStatus }: { key: string; readStatus: boolean }) => {
        runInAction('CHNAGE_READ_STATUS', () => {
            this.insuranceStatement && (this.insuranceStatement.read = readStatus);
            const insuranceStatements = this.insuranceStatements.filter(ins => {
                if (ins.key === key) {
                    ins.read = readStatus;
                }
                return ins;
            });
            this.insuranceStatements = insuranceStatements;
            this.visible = false;
        });
    };
}

export default new InsuranceStatementStore();
